export default __webpack_public_path__ + "static/media/api-testing.5a1ba6bc.svg";